export interface ApiPathProps {
  massageID: string;
  action: string;
  url: string;
}

export type StatusRedux = "ok" | "error" | "pending" | "init";

export interface ErrorAPI {
  code: string;
  message: string;
}

export const ApiKey = {
  /* Quản lý tài khoản */
  QUERY_ACCOUNT_LIST: "QUERY_ACCOUNT_LIST", // Lấy ds tài khoản
  QUERY_ACCOUNT_DETAIL: "QUERY_ACCOUNT_DETAIL", // Lấy chi tiết tài khoản
  CHANGE_PASSWORD: "CHANGE_PASSWORD", // Yêu câù đổi mật khẩu
  CHANGE_PASSWORD_AUTHORIZATION: "CHANGE_PASSWORD_AUTHORIZATION", // Xác thực đổi mk
  GET_LIMIT_REMAIN: "GET_LIMIT_REMAIN", // Lấy hạn mức giao dịch ngày
  GET_CUSTOMER_POSITION: "GET_CUSTOMER_POSITION", // Lấy ds tài khoản customer
  GET_ACCOUNT_DETAIL_BY_PHONE: "GET_ACCOUNT_DETAIL_BY_PHONE", // Lấy thông tin tk qua sđt

  // Sao kê tài khoản
  ACCOUNT_STATEMENT_V2: "ACCOUNT_STATEMENT_V2", // Lâý ds sao kê
  ACCOUNT_TRANSACTION_HISTORY: "ACCOUNT_TRANSACTION_HISTORY", // Lâý ds lịch sử giao dịch
  ACCOUNT_STATEMENT_BACKUP: "ACCOUNT_STATEMENT_BACKUP", // Xuất sổ phụ sao kê
  ACCOUNT_STATEMENT_DETAIL_V2: "ACCOUNT_STATEMENT_DETAIL_V2", // Lấy chi tiết sao kê

  // Tài khoản Loyalty
  GET_ACCOUNT_LOYALTY: "GET_ACCOUNT_LOYALTY", // Lấy thông tin tài khoản loyalty
  GET_LIST_PRESENT_LOYALTY: "GET_LIST_PRESENT_LOYALTY", // Lấy danh sách quà loyalty
  GET_DETAIL_PRESENT_LOYALTY: "GET_DETAIL_PRESENT_LOYALTY", // Lấy chi tiết quà
  GET_LOYALTY_WEBVIEW: "GET_LOYALTY_WEBVIEW", // Lấy link webview đổi quà

  /* Quản lý thụ hưởng */
  GET_PROFILES: "GET_PROFILES", // Lâý danh sách thụ hưởng
  CREATE_PROFILE: "CREATE_PROFILE", // add profile thụ hưởng
  CREATE_TEMPLATE: "CREATE_TEMPLATE", // add template thụ hưởng

  TRANS_MAKE_FEE: "TRANS_MAKE_FEE", // Lấy thông tin lệ phí

  /* Chuyển tiền */
  TRANS_CIF_TRANSFER_INFO: "TRANS_CIF_TRANSFER_INFO", // Lấy thông tin Chuyển khoản
  TRANS_CHECK_TRANSFER_INFO: "TRANS_CHECK_TRANSFER_INFO", // Xác nhận chuyển tiền

  // Chuyển khoản nội bộ
  TRANS_CIF_TRANSFER: "TRANS_CIF_TRANSFER", // Chuyển khoản nội bộ/liên ngânn hàng
  TRANS_AUTHORIZE_TRANSFER: "TRANS_AUTHORIZE_TRANSFER", // Xác thực Chuyển khoản nội bộ/liên ngânn hàng

  // Chuyển khoản 24/7
  TRANS_CIF_TRANSFER_DIRECT_INFO: "TRANS_CIF_TRANSFER_DIRECT_INFO", // Chuyển khoản 247 check tk nhận
  TRANS_CIF_TRANSFER_DIRECT: "TRANS_CIF_TRANSFER_DIRECT", // Chuyển khoản 247
  TRANS_AUTHORIZE_TRANSFER_DIRECT: "TRANS_AUTHORIZE_TRANSFER_DIRECT", // Xác thực Chuyển khoản 247

  // Chuyển khoản Chứng khoán
  TRANS_CIF_TRANSFER_BANK_STOCK: "TRANS_CIF_TRANSFER_BANK_STOCK", // Lấy ds chi nhánh Công ty chứng khoán

  /* Thanh toán */
  // Nạp tiền
  PAYMENT_TOP_UP_INFO: "PAYMENT_TOP_UP_INFO", // Lấy thông tin dv Topup
  PAYMENT_TOP_UP_CREATE: "PAYMENT_TOP_UP_CREATE", // Nhập liệu Topup
  PAYMENT_TOP_UP_CHECK_INFO: "PAYMENT_TOP_UP_CHECK_INFO", // Xác nhận Topup
  PAYMENT_TOP_UP_AUTHORIZE_INFO: "PAYMENT_TOP_UP_AUTHORIZE_INFO", // Xác thực Topup
  // Nạp tiền tự động
  PAYMENT_AUTO_TOP_UP_LIST: "PAYMENT_AUTO_TOP_UP_LIST", // Lấy DS đăng ký Auto Topup
  PAYMENT_AUTO_TOP_UP_DELETE: "PAYMENT_AUTO_TOP_UP_DELETE", // Huỷ lệnh đăng ký Auto Topup
  PAYMENT_AUTO_TOP_UP_LIST_PROVIDER: "PAYMENT_AUTO_TOP_UP_LIST_PROVIDER", // Lấy DS nhà mạng Auto Topup
  PAYMENT_AUTO_TOP_UP_VALID_PHONE: "PAYMENT_AUTO_TOP_UP_VALID_PHONE", // Kiểm tra sđt đk Auto Topup
  PAYMENT_AUTO_TOP_UP_CREATE: "PAYMENT_AUTO_TOP_UP_CREATE", // Đăng ký Auto Topup
  PAYMENT_AUTO_TOP_UP_AUTHORIZE_INFO: "PAYMENT_AUTO_TOP_UP_AUTHORIZE_INFO", // Xác thực Auto Topup
  PAYMENT_AUTO_TOP_UP_TRANSACTION: "PAYMENT_AUTO_TOP_UP_TRANSACTION", // Lấy lịch sử giao dịch dv Auto Topup

  // Thanh toán hoá đơn
  PAYMENT_BILLING_INFO: "PAYMENT_BILLING_INFO", // Lấy thông tin dv thanh toán hoá đơn
  PAYMENT_BILLING_INFO_PACKAGE: "PAYMENT_BILLING_INFO_PACKAGE", // Lấy thông tin dv thanh toán hoá đơn
  PAYMENT_BILLING_CREATE: "PAYMENT_BILLING_CREATE", // nhập liệu thanh toán hoá đơn
  PAYMENT_BILLING_CHECK_INFO: "PAYMENT_BILLING_CHECK_INFO", // Xác nhận thanh toán hoá đơn
  PAYMENT_BILLING_AUTHORIZE_INFO: "PAYMENT_BILLING_AUTHORIZE_INFO", // Xác thực thanh toán hoá đơn
  // Thanh toán hoá đơn tự động
  PAYMENT_AUTO_BILLING_LIST: "PAYMENT_AUTO_BILLING_LIST", // Lấy DS đăng ký Auto billing
  PAYMENT_AUTO_BILLING_DELETE: "PAYMENT_AUTO_BILLING_DELETE", // Huỷ lệnh đăng ký Auto billing
  PAYMENT_AUTO_BILLING_VALID_CUSTOMER: "PAYMENT_AUTO_BILLING_VALID_CUSTOMER", // Kiểm tra mã hoá đơn đk Auto billing
  PAYMENT_AUTO_BILLING_CREATE: "PAYMENT_AUTO_BILLING_CREATE", // Đăng ký Auto billing
  PAYMENT_AUTO_BILLING_AUTHORIZE_INFO: "PAYMENT_AUTO_BILLING_AUTHORIZE_INFO", // Xác thực Auto billing
  PAYMENT_AUTO_BILLING_TRANSACTION: "PAYMENT_AUTO_BILLING_TRANSACTION", // Lấy lịch sử giao dịch dv Auto billing

  // Dịch vụ thẻ
  GET_CARD_LIST: "GET_CARD_LIST", // DS thẻ tín dụng
  GET_CARD_DETAIL: "GET_CARD_DETAIL", // Lấy chi tiết thẻ
  CARD_ACTIVATE: "CARD_ACTIVATE", // Kích hoạt thẻ
  CARD_UPDATE_STATUS: "CARD_UPDATE_STATUS", // Mở/ Khoá thẻ
  CARD_UPDATE_E_COM_STATUS: "CARD_UPDATE_E_COM_STATUS", // Mở/ Khoá giao dịch trực tuyến
  CARD_SHOW_FULL_NUM: "CARD_SHOW_FULL_NUM", // Xem full số thẻ
  CARD_HISTORY: "CARD_HISTORY", // Lịch sử giao dịch
  CARD_STATEMENT: "CARD_STATEMENT", // Sao kê thẻ tín dụng
  CARD_PHYSICAL_REGISTER: "CARD_PHYSICAL_REGISTER", // Đăng ký thẻ vật lý
  CARD_AUTH: "CARD_AUTH", // Xác thực dv thẻ
  // Thanh toán thẻ tín dụng
  PAYMENT_CARD_CREATE: "PAYMENT_CARD_CREATE", // thanh toán thẻ tín dụng create
  PAYMENT_CARD_CONFIRM: "PAYMENT_CARD_CONFIRM", // thanh toán thẻ tín dụng confirm
  PAYMENT_CARD_AUTH: "PAYMENT_CARD_AUTH", // thanh toán thẻ tín dụng auth

  // Tiết kiệm
  TERM_DEPOSIT_LIST: "TERM_DEPOSIT_LIST", // Lấy ds sổ tiết kiệm

  // Mở sổ tiết kiệm
  TERM_DEPOSIT_INFO: "TERM_DEPOSIT_INFO", // Lấy thông tin dv tiết kiệm
  TERM_DEPOSIT_PERIOD: "TERM_DEPOSIT_PERIOD", // Lấy kỳ hạn
  TERM_DEPOSIT_EXPIRE: "TERM_DEPOSIT_EXPIRE", // Lấy hình thức đáo hạn
  TERM_DEPOSIT_OPEN_CREATE: "TERM_DEPOSIT_OPEN_CREATE", // Mở sổ create
  TERM_DEPOSIT_OPEN_CHECK_CODE: "TERM_DEPOSIT_OPEN_CHECK_CODE", // Mở sổ create check code
  TERM_DEPOSIT_OPEN_CONFIRM: "TERM_DEPOSIT_OPEN_CONFIRM", // Mở sổ confirm
  TERM_DEPOSIT_OPEN_AUTH: "TERM_DEPOSIT_OPEN_AUTH", // Mở sổ auth
  TERM_DEPOSIT_OPEN_PROMOTIONS: "TERM_DEPOSIT_OPEN_PROMOTIONS", // Xác nhận tham gia CTKM
  //Nạp tiền vào sổ
  TERM_DEPOSIT_LIST_TOP_UP: "TERM_DEPOSIT_LIST_TOP_UP", // DS sổ tiết kiệm nạp tiền
  TERM_DEPOSIT_TOP_UP_CREATE: "TERM_DEPOSIT_TOP_UP_CREATE", // Nạp tiền tiết kiệm create
  TERM_DEPOSIT_TOP_UP_CONFIRM: "TERM_DEPOSIT_TOP_UP_CONFIRM", // Nạp tiền tiết kiệm confirm
  TERM_DEPOSIT_TOP_UP_AUTH: "TERM_DEPOSIT_TOP_UP_AUTH", // Nạp tiền tiết kiệm auth
  // Tất toán sổ tk
  TERM_DEPOSIT_LIST_STATEMENT: "TERM_DEPOSIT_LIST_STATEMENT", // DS sổ tiết kiệm rút tiền / tất toán
  TERM_DEPOSIT_STATEMENT_CREATE: "TERM_DEPOSIT_STATEMENT_CREATE", // Rút tiền / tất toán sổ tiết kiệm create
  TERM_DEPOSIT_STATEMENT_CONFIRM: "TERM_DEPOSIT_STATEMENT_CONFIRM", // Rút tiền / tất toán sổ tiết kiệm confirm
  TERM_DEPOSIT_STATEMENT_AUTH: "TERM_DEPOSIT_STATEMENT_AUTH", // Rút tiền / tất toán sổ tiết kiệm auth
};

export const ApiPathManager = (key: string) => {
  let obj: ApiPathProps = { action: "", massageID: "", url: "" };

  switch (key) {
    // Quản lý tài khoản
    case "QUERY_ACCOUNT_LIST":
      obj = { massageID: "QUERY_ACCOUNT_LIST", action: "N", url: "queryAccountList" }; // Lấy ds tài khoản
      break;
    case "QUERY_ACCOUNT_DETAIL":
      obj = { massageID: "QUERY_ACCOUNT_DETAIL", action: "Y", url: "queryAccountDetail" }; // Lấy chi tiết tài khoản
      break;
    case "GET_ACCOUNT_DETAIL_BY_PHONE":
      obj = { massageID: "", action: "", url: "getAccountByPhone" }; // Lấy thông tin tk qua sđt
      break;
    case "CHANGE_PASSWORD":
      obj = { massageID: "", action: "Y", url: "changePasswordRequest" }; // Đổi password
      break;
    case "CHANGE_PASSWORD_AUTHORIZATION":
      obj = { massageID: "", action: "Y", url: "changePasswordVerify" }; // Xác thực Đổi password
      break;
    case "GET_LIMIT_REMAIN":
      obj = { massageID: "GET_LIMIT_REMAIN", action: "Y", url: "getLimitRemain" }; // Lấy hạn mức giao dịch ngày
      break;
    case "GET_CUSTOMER_POSITION":
      obj = { massageID: "GET_CUSTOMER_POSITION", action: "Y", url: "getCustomerPosition" }; // Lấy ds tài khoản
      break;
    case "ACCOUNT_STATEMENT_V2":
      obj = { massageID: "GET_IB_STATEMENT_V2", action: "Y", url: "getIbStatementV2" }; // Lâý ds sao kê
      break;
    case "ACCOUNT_STATEMENT_DETAIL_V2":
      obj = { massageID: "GET_IB_STATEMENT_DETAIL_V2", action: "Y", url: "getIbStatementDetailV2" }; // xuất sổ phụ sao kê
      break;
    case "ACCOUNT_TRANSACTION_HISTORY":
      obj = { massageID: "QUERY_GET_HISTORY_TRANS", action: "Y", url: "queryGetHistoryTrans" }; // Lâý ds lịch sử giao dịch
      break;
    case "ACCOUNT_STATEMENT_BACKUP":
      obj = { massageID: "QUERY_GET_STATEMENTS", action: "Y", url: "queryGetStatements" }; // xuất sổ phụ sao kê
      break;

    // Quản lý Loyalty
    case "GET_ACCOUNT_LOYALTY":
      obj = { massageID: "QUERY_ACCOUNT_LOYALTY", action: "Y", url: "queryAccountLoyalty" }; // Lấy thông tin tài khoản loyalty
      break;
    case "GET_LIST_PRESENT_LOYALTY":
      obj = { massageID: "QUERY_LISTPRESENT_LOYALTY", action: "Y", url: "queryListPresentLoyalty" }; // Lấy danh sách quà loyalty
      break;
    case "GET_DETAIL_PRESENT_LOYALTY":
      obj = { massageID: "QUERY_DETAIL_PRESENT", action: "Y", url: "queryPresentDetailById" }; // Lấy chi tiết quà
      break;
    case "GET_LOYALTY_WEBVIEW":
      obj = { massageID: "", action: "", url: "getLoyaltyWebView" }; // Lấy chi tiết quà
      break;

    // Quản lý danh sách Thụ hưởng
    case "GET_PROFILES":
      obj = { massageID: "GET_PROFILES", action: "N", url: "getProfiles" }; // Lâý danh sách thụ hưởng
      break;
    case "CREATE_PROFILE":
      obj = { massageID: "CREATE_PROFILE", action: "Y", url: "createProfile" }; // Thêm profile thụ hưởng
      break;
    case "CREATE_TEMPLATE":
      obj = { massageID: "CREATE_TEMPLATE", action: "Y", url: "createTemplate" }; // Thêm template thụ hưởng
      break;

    // Chuyển tiền
    case "TRANS_MAKE_FEE":
      obj = { massageID: "TRANS_MAKE_FEE", action: "Y", url: "makeTransfer" }; // Lấy thông tin phí chuyển tiền
      break;
    case "TRANS_CIF_TRANSFER_INFO":
      obj = { massageID: "TRANS_CIF_TRANSFER", action: "N", url: "makeTransfer" }; // Lấy thông tin Chuyển khoản
      break;
    case "TRANS_CIF_TRANSFER_BANK_STOCK":
      obj = { massageID: "TRANS_CIF_TRANSFER", action: "PSIBRANCH", url: "makeTransfer" }; // Lấy ds chi nhánh Công ty chứng khoán
      break;
    // Chuyển tiền nội bộ / Liên ngân hàng / Chứng khoán
    case "TRANS_CIF_TRANSFER":
      obj = { massageID: "TRANS_CIF_TRANSFER", action: "Y", url: "makeTransfer" }; // Chuyển khoản nội bộ
      break;
    case "TRANS_CHECK_TRANSFER_INFO":
      obj = { massageID: "TRANS_CHECK_TRANSFER_INFO", action: "Y", url: "checkInfoTransfer" }; // Xác nhận chuyển nội bộ
      break;
    case "TRANS_AUTHORIZE_TRANSFER":
      obj = { massageID: "TRANS_AUTHORIZE_TRANSFER", action: "Y", url: "authorizeTransfer" }; // Xác thực Chuyển khoản nội bộ
      break;
    // Chuyển tiềnn 24/7
    case "TRANS_CIF_TRANSFER_DIRECT_INFO":
      obj = { massageID: "TRANS_CIF_TRANSFER_DIRECT", action: "Y", url: "makeTransferDirect" }; // Chuyển khoản 247 check tk nhận
      break;
    case "TRANS_CIF_TRANSFER_DIRECT":
      obj = { massageID: "TRANS_CIF_TRANSFER_DIRECT", action: "Y", url: "makeTransferDirect" }; // Chuyển khoản 247
      break;
    case "TRANS_AUTHORIZE_TRANSFER_DIRECT":
      obj = { massageID: "TRANS_AUTHORIZE_TRANSFER_DIRECT", action: "Y", url: "authorizeTransferDirect" }; // Xác thực Chuyển khoản 247
      break;

    // Dịch vụ Thanh toán
    // Nạp tiền
    case "PAYMENT_TOP_UP_INFO":
      obj = { massageID: "PAYMENT_TOPUP", action: "N", url: "makePaymentTopup" }; // Lấy thông tin dv Topup
      break;
    case "PAYMENT_TOP_UP_CREATE":
      obj = { massageID: "PAYMENT_TOPUP", action: "Y", url: "makePaymentTopup" }; // Nhập liệu Topup
      break;
    case "PAYMENT_TOP_UP_CHECK_INFO":
      obj = { massageID: "PAYMENT_TOPUP_CHECK_INFO", action: "Y", url: "checkPaymentTopup" }; // Xác nhận Topup
      break;
    case "PAYMENT_TOP_UP_AUTHORIZE_INFO":
      obj = { massageID: "PAYMENT_TOPUP_AUTHORIZE_INFO", action: "Y", url: "authorizePaymentTopup" }; // Xác thực Topup
      break;
    // Nạp tiền tự động Auto Topup
    case "PAYMENT_AUTO_TOP_UP_LIST":
      obj = { massageID: "", action: "", url: "autoTopup/getListPhone" }; // Lấy DS đăng ký Auto Topup
      break;
    case "PAYMENT_AUTO_TOP_UP_DELETE":
      obj = { massageID: "", action: "", url: "autoTopup/cancel" }; // Huỷ lệnh đăng ký Auto Topup
      break;
    case "PAYMENT_AUTO_TOP_UP_LIST_PROVIDER":
      obj = { massageID: "", action: "", url: "autoTopup/getListProvider" }; // Lấy DS nhà mạng Auto Topup
      break;
    case "PAYMENT_AUTO_TOP_UP_VALID_PHONE":
      obj = { massageID: "", action: "", url: "autoTopup/checkPhoneRegister" }; // Kiểm tra sđt đk Auto Topup
      break;
    case "PAYMENT_AUTO_TOP_UP_CREATE":
      obj = { massageID: "", action: "", url: "autoTopup/register" }; // Đăng ký Auto Topup
      break;
    case "PAYMENT_AUTO_TOP_UP_AUTHORIZE_INFO":
      obj = { massageID: "", action: "", url: "autoTopup/verifyRegister" }; // Xác thực Auto Topup
      break;
    case "PAYMENT_AUTO_TOP_UP_TRANSACTION":
      obj = { massageID: "", action: "", url: "authorizePaymentTopup" }; // Lấy lịch sử giao dịch dv Auto Topup
      break;

    // Thanh toán hoá đơn
    case "PAYMENT_BILLING_INFO":
      obj = { massageID: "PAYMENT_BILLING", action: "N", url: "makePaymentBilling" }; // Lấy thông tin dv thanh toán hoá đơn
      break;
    case "PAYMENT_BILLING_INFO_PACKAGE":
      obj = { massageID: "PAYMENT_BILLING", action: "PKGS", url: "makePaymentBilling" }; // Lấy thông tin dv thanh toán hoá đơn
      break;
    case "PAYMENT_BILLING_CREATE":
      obj = { massageID: "PAYMENT_BILLING", action: "Y", url: "makePaymentBilling" }; // nhập liệu thanh toán hoá đơn
      break;
    case "PAYMENT_BILLING_CHECK_INFO":
      obj = { massageID: "PAYMENT_BILLING_CHECK_INFO", action: "Y", url: "checkPaymentBilling" }; // Xác nhận thanh toán hoá đơn
      break;
    case "PAYMENT_BILLING_AUTHORIZE_INFO":
      obj = { massageID: "PAYMENT_BILLING_AUTHORIZE_INFO", action: "Y", url: "authorizePaymentBilling" }; // Xác thực thanh toán hoá đơn
      break;
    // Thanh toán hoá đơn tự động Auto billing
    case "PAYMENT_AUTO_BILLING_LIST":
      obj = { massageID: "", action: "", url: "autoBilling/getListBill" }; // Lấy DS đăng ký Auto billing
      break;
    case "PAYMENT_AUTO_BILLING_DELETE":
      obj = { massageID: "", action: "", url: "autoBilling/cancel" }; // Huỷ lệnh đăng ký Auto billing
      break;
    case "PAYMENT_AUTO_BILLING_VALID_CUSTOMER":
      obj = { massageID: "", action: "", url: "autoBilling/checkBillRegister" }; // Kiểm tra mã hoá đơn đk Auto billing
      break;
    case "PAYMENT_AUTO_BILLING_CREATE":
      obj = { massageID: "", action: "", url: "autoBilling/register" }; // Đăng ký Auto billing
      break;
    case "PAYMENT_AUTO_BILLING_AUTHORIZE_INFO":
      obj = { massageID: "", action: "", url: "autoBilling/verifyRegister" }; // Xác thực Auto billing
      break;
    case "PAYMENT_AUTO_BILLING_TRANSACTION":
      obj = { massageID: "", action: "", url: "makePaymentBilling" }; // Lấy lịch sử giao dịch dv Auto billing
      break;

    // Dịch vụ thẻ
    case "GET_CARD_LIST":
      obj = { massageID: "", action: "", url: "getListCard" }; // Lấy DS thẻ
      break;
    case "GET_CARD_DETAIL":
      obj = { massageID: "", action: "", url: "getCardDetail" }; // Lấy chi thiết thẻ
      break;
    case "CARD_ACTIVATE":
      obj = { massageID: "", action: "", url: "activateCard" }; // Kích hoạt thẻ
      break;
    case "CARD_UPDATE_STATUS":
      obj = { massageID: "", action: "", url: "updateCardStatus" }; // Mở/ Khoá thẻ
      break;
    case "CARD_UPDATE_E_COM_STATUS":
      obj = { massageID: "", action: "", url: "updateEcomStatus" }; // Mở/ Khoá giao dịch trực tuyến
      break;
    case "CARD_SHOW_FULL_NUM":
      obj = { massageID: "", action: "", url: "getFullCard" }; // Xem full số thẻ
      break;
    case "CARD_HISTORY":
      obj = { massageID: "", action: "", url: "getCardStatement" }; // Lịch sử giao dịch thẻ
      break;
    case "CARD_STATEMENT":
      obj = { massageID: "", action: "", url: "getListInvoiceCard" }; // Sao kê thẻ tín dụng
      break;
    case "CARD_PHYSICAL_REGISTER":
      obj = { massageID: "", action: "", url: "registerCard" }; // Đăng ký thẻ vật lý
      break;
    case "CARD_AUTH":
      obj = { massageID: "", action: "", url: "verifyCard" }; // Xác thực dv thẻ
      break;

    // Thanh toán thẻ tín dụng
    case "PAYMENT_CARD_CREATE":
      obj = { massageID: "CARD_PAYMENT", action: "Y", url: "creditPaymentInquiry" }; // nhập liệu thanh toán thẻ tín dụng
      break;
    case "PAYMENT_CARD_CONFIRM":
      obj = { massageID: "CARD_PAYMENT_CHECK_INFO", action: "Y", url: "creditPayment" }; // Xác nhận thanh toán thẻ tín dụng
      break;
    case "PAYMENT_CARD_AUTH":
      obj = { massageID: "CARD_PAYMENT_AUTHORIZE_INFO", action: "Y", url: "verifyCardPayment" }; // Xác thực thanh toán thẻ tín dụng
      break;

    // Tiết kiệm
    case "TERM_DEPOSIT_LIST":
      obj = { massageID: "DEPOSITS_LIST", action: "QUERY", url: "depositsList" }; // DS sổ tiết kiệm
      break;
    // Mở sổ tiết kiệm
    case "TERM_DEPOSIT_INFO":
      obj = { massageID: "CURRENT_LIST", action: "CREATE", url: "depositsList" }; // Lấy thông tin tiết kiệm
      break;
    case "TERM_DEPOSIT_PERIOD":
      obj = { massageID: "CREATE_DEPOSITS", action: "FDTERM", url: "stepOneDeposits" }; // Lấy ds kỳ hạn
      break;
    case "TERM_DEPOSIT_EXPIRE":
      obj = { massageID: "CREATE_DEPOSITS", action: "INTTERM", url: "stepOneDeposits" }; // Xác ds Hình thức đáo hạn
      break;
    case "TERM_DEPOSIT_OPEN_CHECK_CODE":
      obj = { massageID: "CREATE_DEPOSITS", action: "CHECKCODE", url: "stepOneDeposits" }; // Check code mở sổ
      break;
    case "TERM_DEPOSIT_OPEN_CREATE":
      obj = { massageID: "CREATE_DEPOSITS", action: "Y", url: "stepOneDeposits" }; // nhập liệu Mở sổ tiết kiệm
      break;
    case "TERM_DEPOSIT_OPEN_CONFIRM":
      obj = { massageID: "CONFIRM_CREATE_DEPOSITS", action: "SUBMIT", url: "stepTwoDeposits" }; // Xác nhận Mở sổ tiết kiệm
      break;
    case "TERM_DEPOSIT_OPEN_AUTH":
      obj = { massageID: "CHECK_CREATE_DEPOSITS", action: "Y", url: "stepThreeDeposits" }; // Xác thực Mở sổ tiết kiệm
      break;
    case "TERM_DEPOSIT_OPEN_PROMOTIONS":
      obj = { massageID: "CHECK_CREATE_DEPOSITS", action: "PROMOTION", url: "stepThreeDeposits" }; // Xác nhận tham gia CTKM
      break;
    // Nộp tiền sổ tiết kiệm
    case "TERM_DEPOSIT_LIST_TOP_UP":
      obj = { massageID: "DEPOSITS_LIST", action: "SUBMIT", url: "depositsList" }; // DS sổ tiết kiệm nạp tiền
      break;
    case "TERM_DEPOSIT_TOP_UP_CREATE":
      obj = { massageID: "SUBMIT_DEPOSITS", action: "Y", url: "stepOneDeposits" }; // nhập liệu Nạp tiền tiết kiệm
      break;
    case "TERM_DEPOSIT_TOP_UP_CONFIRM":
      obj = { massageID: "CONFIRM_SUBMIT_DEPOSITS", action: "SUBMIT", url: "stepTwoDeposits" }; // Xác nhận Nạp tiền tiết kiệm
      break;
    case "TERM_DEPOSIT_TOP_UP_AUTH":
      obj = { massageID: "CHECK_SUBMIT_DEPOSITS", action: "Y", url: "stepThreeDeposits" }; // Xác thực Nạp tiền tiết kiệm
      break;
    // Tất toán sổ tiết kiệm
    case "TERM_DEPOSIT_LIST_STATEMENT":
      obj = { massageID: "DEPOSITS_LIST", action: "WITHDRAW", url: "depositsList" }; // DS sổ tiết kiệm rút tiền / tất toán
      break;
    case "TERM_DEPOSIT_STATEMENT_CREATE":
      obj = { massageID: "WITHDRAW_DEPOSITS", action: "Y", url: "stepOneDeposits" }; // nhập liệu Rút tiền / tất toán sổ tiết kiệm
      break;
    case "TERM_DEPOSIT_STATEMENT_CONFIRM":
      obj = { massageID: "CONFIRM_WITHDRAW_DEPOSITS", action: "SUBMIT", url: "stepTwoDeposits" }; // Xác nhận Rút tiền / tất toán sổ tiết kiệm
      break;
    case "TERM_DEPOSIT_STATEMENT_AUTH":
      obj = { massageID: "CHECK_WITHDRAW_DEPOSITS", action: "Y", url: "stepThreeDeposits" }; // Xác thực Rút tiền / tất toán sổ tiết kiệm
      break;
    default:
      break;
  }
  return obj;
};

export const ServiceCode = {
  TRANSFER_LOCAL_SAME_CIF: "01",
  TRANSFER_LOCAL_OTHER_CIF: "02",
  TRANSFER_LOCAL_CHARITY: "05",
  TRANSFER_247: "12",
  TRANSFER_FOREIGN: "11",
  TRANSFER_STOCK: "04",
  TRANSFER_BY_CODE: "17",
  PAYMENT_TOP_UP_PHONE: "20",
  PAYMENT_TOP_UP_OTHER: "25",
  PAYMENT_BILLING: "30",
  BENE_LOCAL: "02",
  BENE_FOREIGN: "11",
  TERM_DEPOSIT_OPEN: "40",
  TERM_DEPOSIT_TOPUP: "41",
  TERM_DEPOSIT_STATEMENT: "42",
  PAYMENT_CARD: "31",
  PAYMENT_CARD_OTHER: "35",
  PAYMENT_QR_CODE: "70",
  CARD: "CARD",
  AUTO_TOP_UP: "23",
  AUTO_BILLING: "34",
};
